import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormNumberTextField, Stack } from "sprint-common-web";

import { useCreateResolutionForm } from "./useCreateResolutionForm";

export interface CreateResolutionFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface CreateResolutionFormInputs {
    width: number;
    height: number;
}

export const CreateResolutionForm: FunctionComponent<CreateResolutionFormProps> = (
    props: CreateResolutionFormProps
) => {
    const { errors, control, formState, reset, handleSubmit } = useForm<CreateResolutionFormInputs>({
        defaultValues: {
            width: undefined,
            height: undefined
        },
        criteriaMode: "all"
    });

    const { createResolution } = useCreateResolutionForm();

    const handleCreateResolution = async (inputs: CreateResolutionFormInputs) => {
        await createResolution(inputs);
        props.onSubmit();
        reset();
    };

    const handleCancelButtonClick = () => {
        reset();
        props.onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleCreateResolution)}>
            <Stack verticalAlign="space-between">
                <FormFields>
                    <FormNumberTextField
                        label="Width"
                        control={control}
                        name="width"
                        errors={errors}
                        rules={{
                            required: "Width is required field"
                        }}
                    />
                    <FormNumberTextField
                        label="Height"
                        control={control}
                        name="height"
                        errors={errors}
                        rules={{
                            required: "Height is required field"
                        }}
                    />
                </FormFields>
                <FormActions
                    isLoading={formState.isSubmitting || formState.isValidating}
                    onCancel={handleCancelButtonClick}
                />
            </Stack>
        </Form>
    );
};
